module.exports = __webpack_public_path__ + "static/media/america-necaxa.7e367fe5.jpg";